<script setup lang="ts">
    import { defaultAutocompleteConverter } from "@/components/forms/inputs/Autocomplete/helpers";
    import { useStore } from "@/store";
    import { flashWarning } from "@/utils";

    const fetchForsakringsbolag = async ({ query }: { query?: string } = {}) => {
        const store = useStore();

        try {
            const params: { q?: string } = {};

            if (query) {
                params.q = query;
            }

            const { subsetName } = await store.dispatch("forsakringsbolag/fetchForsakringsbolag", {
                filterParams: params,
                displayMode: true,
            });

            return store.getters["forsakringsbolag/forsakringsbolagSubset"]({ subsetName, displayMode: true });
        } catch (error) {
            flashWarning("Kunde inte hämta försäkringsbolag.");
        }
    };
</script>

<template>
    <KAutocomplete
        name="forsakringsbolag"
        label="Försäkringsbolag"
        :options="fetchForsakringsbolag"
        :onSearch="fetchForsakringsbolag"
        :converter="defaultAutocompleteConverter"
    />
</template>

<style lang="scss" scoped></style>
